import { getVars, setVars } from './envVars';

export default (variables = {}) => {
  const vars = { ...getVars(), ...variables };

  // в билде на деве нет NODE_ENV, но есть MODE === 'dev'.
  const isDev = vars.NODE_ENV === 'development' || vars.MODE === 'development';
  const isTest = vars.NODE_ENV === 'test' || vars.MODE === 'test';

  const isModeDev = vars.NODE_ENV === 'development' || vars.MODE === 'dev';
  const isProd = !isModeDev && !isTest;
  // const isDev = false;

  const usingProxy = isDev;
  const appBasePathSettings = vars.VITE_APP_BASE_PATH_SETTINGS || '/api';

  const appBasePath = vars.VITE_APP_BASE_PATH || '/';

  return {
    hostName: vars.VITE_HOSTNAME || 'epk',
    appBasePath: vars.VITE_APP_BASE_PATH || '/',
    appDevServerPort: vars.VITE_APP_SERVER_PORT
      ? Number(vars.VITE_APP_SERVER_PORT)
      : 8080,
    // isAuthEnabled: !isDev,
    isAuthEnabled: true,
    isModeDevelopment: isDev,
    isModeDev,
    isProd,
    appBasePathSettings,
    proxyEsiaPrefix: '/esia',
    getVars,
    setVars,
    usingProxy,
    basePath: usingProxy ? appBasePathSettings : '',
    logoutSessionStorageKey: 'LOGOUT',
    routerBasePath: vars.VITE_ROUTER_BASE_PATH || appBasePath,
  };
};
